import { Entity } from '@backstage/catalog-model'
import {
  BACKSTAGE_SOURCE_LOCATION_ANNOTATION,
  extractGithubRepoFromEntity,
} from '@internal/backstage-plugin-veho-backstage-common'

import { CodeCoverageQuery } from '../../api'

export {
  BACKSTAGE_MANAGED_BY_LOCATION_ANNOTATION,
  BACKSTAGE_SOURCE_LOCATION_ANNOTATION,
} from '@internal/backstage-plugin-veho-backstage-common'
export const CODE_COVERAGE_PROJECT_SLUG_OVERRIDE_ANNOTATION = 'codecov.io/project-slug'

export class InvalidCodeCoverageAnnotationError extends Error {}

const parseOverride = (value: string): CodeCoverageQuery => {
  const [owner, repo, ...rest] = value.split('/')
  if (!owner || !repo || rest.length > 0) {
    throw new InvalidCodeCoverageAnnotationError(
      `Annotation '${CODE_COVERAGE_PROJECT_SLUG_OVERRIDE_ANNOTATION}' must be in the form '<owner>/<repo>', got '${value}'`
    )
  }
  return { owner, repo }
}

export const readCoverageQuery = (entity: Entity): CodeCoverageQuery => {
  const override = entity.metadata.annotations?.[CODE_COVERAGE_PROJECT_SLUG_OVERRIDE_ANNOTATION]
  if (override) return parseOverride(override)

  const repo = extractGithubRepoFromEntity(entity)
  if (repo) return repo

  throw new InvalidCodeCoverageAnnotationError(
    `Unable to determine the GitHub repo for this entity. Expected '${BACKSTAGE_SOURCE_LOCATION_ANNOTATION}' to point at a github.com URL (auto-populated by GitHub discovery), or set the override '${CODE_COVERAGE_PROJECT_SLUG_OVERRIDE_ANNOTATION}'.`
  )
}
